import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-delete-template',
  templateUrl: './dialog-delete-template.component.html',
  styleUrls: ['./dialog-delete-template.component.scss']
})
export class DialogDeleteTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
